import store from '@/store';
import authType from '@/store/types/auth';
import { NavigationGuardNext, Route } from 'vue-router';

export const ifNotAuthenticated = (to: Route, from: Route, next: NavigationGuardNext<Vue>): void => {
  if (!store.getters[`authModule/${authType.getters.IS_AUTHENTICATED}`]) {
    if (to.path === '/') {
      next('/login');
    } else {
      next();
    }
    return;
  }
  next('/');
};
export const ifAuthenticated = (to: Route, from: Route, next: NavigationGuardNext<Vue>): void => {
  if (store.getters[`authModule/${authType.getters.IS_AUTHENTICATED}`]) {
    next();
    return;
  }
  next('/login');
};

export const checkPermissions = (to: Route, from: Route, next: NavigationGuardNext<Vue>, permission: string): void => {
  if (!store.getters[`authModule/${authType.getters.PERMISSIONS}`]
    .includes(permission)) {
    next('/403');
  }
  next();
};
